import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst = {
  ACTION: {
    C10401_getCenterList: {
      api: 'T3010ScheduleService.C10401_getCenterList',
      input: {
        year_month: null
      }
    },
    C10401_getDetailForCenter: {
      api: 'T3010ScheduleService.C10401_getDetailForCenter',
      input: {
        center_no: null,
        year_month: null
      }
    },
    C10401_exportCSV: {
      api: 'T3010ScheduleService.C10401_exportCSV',
      input: {
        center_nos: '',
        year_month: null
      }
    },
  }
}

const module = {
  state: {
    PageConst,
    searchInfo: {
      targetYearMonth: null,
      targetYearMonthCenterList: null,
      targetYearMonthCenterDetail: null,
      selectedCenterNo: null,
      selectedCenterName: null,
    },
    showCenterList: false,
    showCenterDetail: false,

    centerList: [],
    centerGroupList: [],
    centerDetailList: [],
  },

  getters: {},
  mutations: {},
  actions: {
    async C10401_getCenterList ({ state }, payload ) {
      state.searchInfo.selectedCsvCenterNos = []
      const res = await $this.$api.postData({
        data: [{
          ...PageConst.ACTION.C10401_getCenterList,
          input: {
            year_month: payload.year_month,
          }
        }]
      }).catch((e) => {
        this.commit('Notification/SET_NOTIFY_ERROR', {
          text: e.message
        })
      })
      state.centerList = res[0].output.C10401_getSummaryForCenter
      state.centerGroupList = res[0].output.C10401_getSummaryForCenterGroup
      state.searchInfo.targetYearMonthCenterList = payload.year_month

      state.showCenterList = true
    },
    async C10401_getDetailForCenter ({ state }, payload ) {
      const res = await $this.$api.postData({
        data: [{
          ...PageConst.ACTION.C10401_getDetailForCenter,
          input: {
            center_no: payload.center_no,
            year_month: payload.year_month,
          }
        }]
      }).catch((e) => {
        this.commit('Notification/SET_NOTIFY_ERROR', {
          text: e.message
        })
      })
      state.centerDetailList = res[0].output

      state.searchInfo.selectedCenterNo = payload.center_no
      state.searchInfo.selectedCenterName = payload.center_name
      state.searchInfo.targetYearMonthCenterDetail = payload.year_month
      state.showCenterDetail = true
    },
    async C10401_exportCSV ({ state }, payload ) {
      const res = await $this.$api.postData({
        data: [{
          ...PageConst.ACTION.C10401_exportCSV,
          input: {
            center_nos: payload.center_nos,
            year_month: payload.year_month,
          }
        }]
      }).catch((e) => {
        this.commit('Notification/SET_NOTIFY_ERROR', {
          text: e.message
        })
      })
      return res[0].output
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
